// Func = limiting Scope for this file
let lastScrollTop = 0;
let st = window.pageYOffset || document.documentElement.scrollTop;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			// resizeWindow();
		});
		// resizeWindow(); 

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			// scrollDown();
		}); 
		// Pop-in add x
		if($('#content-popin').length>0){
			$('#content-popin .box-content-popin').append('<div class="close-popin"></div>');
			$('#content-popin .close-popin').click(function(){
			$('.box-arrow-popin .arrow').addClass("open");
			$('.box-content-popin').removeClass("open");
			TogglePopIn();	
			});
		}
		

		// BOOKING TOGGLE
		document.querySelectorAll('.js-booking-toggle').forEach(btn => {
			btn.addEventListener('click', e => {
				let bookingModule = document.querySelector('#booking-overlay');
				e.preventDefault();
				bookingModule.classList.add('open');
			});
		});
		document.querySelectorAll('.booking-overlay__close').forEach(btn => {
			btn.addEventListener('click', e => {
				let bookingModule = document.querySelector('#booking-overlay');
				e.preventDefault();
				bookingModule.classList.remove('open');
			});
		});
		
/* 		// Close booking on click outside (fixed datepicker)
		$(window).click(e => {
			if ( $('#bookingModule').length > 0 && $(e.target).closest('#bookingModule').length < 1 && !$(e.target).is('.js-booking-toggle') && !$(e.target).is('body') ){
				document.querySelector('.js-booking-toggle').classList.remove('active');
				document.querySelector('#bookingModule').classList.remove('active');
			}
		}); */
		
		// MAIN NAV TOGGLE
		document.querySelectorAll('.js-navToggle').forEach(btn => {
			btn.addEventListener('click', e => {
				let navModule = e.currentTarget.getAttribute('href');

				e.preventDefault();
				document.querySelector(navModule).classList.toggle('active');
				e.currentTarget.classList.toggle('active');

				document.querySelector('.js-booking-toggle').classList.remove('active');
				document.querySelector('#bookingModule').classList.remove('active');

				for(let el of document.getElementsByClassName('bookingModule')) {
					if ( st < 1 ) {
						el.classList.toggle('zindexUp');
					}
				}
			});
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [];
		let minDateString = '2020-08-01';
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			
			// COVID DISABLED DATES
			/* let d3=$.datepicker.parseDate(DATE_FORMAT,minDateString);
			if (date.getTime() < d3.getTime()){
				DATE_STYLE[0] = false;
				DATE_STYLE[1] = 'disabled-covid';
			}else  */
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[0] = true;
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[0] = true;
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[0] = true;
				DATE_STYLE[1] = '';
			}
			
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
		console.log(DATE_FORMAT);
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			//defaultDate: '2020-06-02',
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		$('.acc-btn').on('click',function(e){
			e.preventDefault();
		   if($(this).hasClass('active')){
			$(this).removeClass("active");
			$(this).next().slideToggle();
		   }else{
			$(".acc-btn").removeClass("active");
			$(".tab-content").slideUp();
			$(this).addClass('active');
			$(this).next().slideToggle();
		   }
		});
		$( "#booking-form .form-entry.date input" ).each(function(){
			let orPlaceholder = $(this).attr('placeholder');
			$(this).on('focus',function(){
				$(this).attr('placeholder','YYYY-MM-DD');
			});
			$(this).on('blur',function(){
				$(this).attr('placeholder',orPlaceholder);
			});
		})

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			
			document.querySelector('#headerNav').classList.remove('active');
			document.querySelector('.js-navToggle').classList.remove('active');
		})
	};

	// TABS ROOMS
	var firstTab = document.querySelector('.list__tabs__item:first-child a');

	if(firstTab){
		firstTab.classList.add('active');
		var filterFirts =  firstTab.getAttribute("data-target");
		var sectionFirst = firstTab.closest('section');
		
		sectionFirst.querySelectorAll('.list__item').forEach( (allDivsFirst) => {
			allDivsFirst.classList.remove('list__item__hide');
		})
		
		var hideSelectorsFirst = '.list__item:not(' + filterFirts + ')';	
		sectionFirst.querySelectorAll(hideSelectorsFirst).forEach( (hideDivsFirst)=> {
			hideDivsFirst.classList.add('list__item__hide');
			document.querySelector('.list__ofrooms').appendChild(hideDivsFirst);
		})

		var tabbuttons = document.querySelectorAll('.list__tabs__btn');
		var tc = 0;
		
		for( tc; tc < tabbuttons.length; tc++){
			tabbuttons[tc].addEventListener('click',function(){
				
				if( ! this.classList.contains('active') ){	
					
					tabbuttons.forEach( (tabbuttons) => { tabbuttons.classList.remove('active') })

					this.classList.add('active');
					var filterdis = this.getAttribute("data-target");
					var section = this.closest('section');

					section.querySelectorAll('.list__item').forEach( (allDivs) => {
						allDivs.classList.remove('list__item__hide');
					})

					if(filterdis){
						var hideSelectors = '.list__item:not(' + filterdis + ')';
						section.querySelectorAll(hideSelectors).forEach( (hideDivs) => {
							hideDivs.classList.add('list__item__hide');
							document.querySelector('.list__ofrooms').appendChild(hideDivs);
						});
					}
					var firtsQuad = document.querySelector('.list__item' + filterdis);
					firtsQuad.querySelectorAll('.animate-fade').forEach( (animated) =>{
						animated.classList.add('fade-in', 'visible');
					});
				}
			});
		}
	}

}());

function scrollW(){
	st = window.pageYOffset || document.documentElement.scrollTop;
	//check scroll down or up for header styles


	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}

	//Check scroll for sticking submenu
	for(let el of document.getElementsByClassName('bookingModule')) {
		if(st > 80){
			if ( st > getElementOffset(el).top ) {
				el.classList.add('fixed');
				if (st > lastScrollTop){
					el.classList.add('down');
					el.classList.remove('up');
				} else{
					el.classList.add('up');
					el.classList.remove('down');
				}
			} else {
				el.classList.remove('fixed');
				el.classList.remove('up');
				el.classList.remove('down');
			}
		}
		el.classList.remove('active', 'zindexUp');
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function getElementOffset(el) {
	const rect = el.getBoundingClientRect();

	return {
		top: rect.top + window.pageYOffset,
		left: rect.left + window.pageXOffset,
	};
}